import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import Skeleton from '@material-ui/lab/Skeleton';
import Details from './details';
import Language from './language';
import Options from './options';

const UserSettingsView = props => (
  <>
    <h1>
      <Translate value="user.account"/>
    </h1>
    <div className="row">
      <div className="card col-12 col-lg-6">
        <div className="card-header">
          <div className="card-title"><Translate value="user.myProfile"/></div>
        </div>
        {props.loading ?
          <div className="flex-container column">
            <Skeleton
              variant="rect"
              height={56}
              width={'100%'}
            />
            <Skeleton
              variant="rect"
              height={56}
              width={'100%'}
            />
            <Skeleton
              variant="rect"
              height={56}
              width={'100%'}
            />
            <Skeleton
              variant="rect"
              height={56}
              width={'100%'}
            />
            <div className="flex-container flex-end mt-5">
              <Skeleton
                variant="rect"
                height={40}
                width={100}
              />
            </div>
          </div> :
          <Details
            onUpdate={props.onUpdate}
            userDetails={props.userDetails}
          />
        }
      </div>
      <div className="col-12 col-lg-6 d-flex flex-column">
        <div className="card">
          <div className="card-header">
            <div className="card-title"><Translate value="user.language"/></div>
          </div>
          <Language/>
        </div>
        <div className="card flex-grow-1">
          <div className="card-header">
            <div className="card-title"><Translate value="user.options.title"/></div>
          </div>
          {props.loading ?
            <div className="flex-container column">
              <Skeleton variant="text"/>
              <Skeleton variant="text"/>
              <div className="flex-container flex-end mt-5">
                <Skeleton
                  variant="rect"
                  height={40}
                  width={100}
                />
              </div>
            </div> :
            <Options
              onUpdate={props.onUpdate}
              userDetails={props.userDetails}
            />
          }
        </div>
      </div>
    </div>
  </>
);

UserSettingsView.propTypes = {
  userDetails: PropTypes.object,
  loading: PropTypes.bool,
  onUpdate: PropTypes.func.isRequired
};

export default UserSettingsView;
